import React from 'react';

const LoadingApplication = props => (
    <div id="LoadingScreen">
        <div className="lds-ripple">
                <div></div>
                <div></div>
                <div></div>
        </div>
    </div>
 );

export default LoadingApplication


// WEBPACK FOOTER //
// ./src/js/pages/Loading.js